module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('span', [_vm._v("To my daughters, Miriam and Louise,"), _c('br'), _vm._v("who put up with my mishegoss.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("Special Dedication:"), _c('br'), _vm._v("To Peter, Bob, Howie, Bob, and Andre:"), _c('br'), _vm._v("The staff of "), _c('i', [_vm._v("Youth’s Companion")]), _vm._v(" wouldn’t have been"), _c('br'), _vm._v("the same without you."), _c('br'), _vm._v("Thanks for twenty years of Fandom.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0